import { BaseUrl } from "../../ApiBaseUrl/ApiBaseUrl";
import {
  GET_VENDOR_DASHBOARD_STATS,
  GET_VENDOR_DASHBOARD_PR_LIST,
  GET_VENDOR_DASHBOARD_SINGLE_PR,
  GET_VENDOR_DASHBOARD_PO_STATS,
  GET_VENDOR_DASHBOARD_PR_STATS,
  GET_VENDOR_DASHBOARD_PR_DATA_BY_FILTER,
  GET_VENDOR_DASHBOARD_PO_DATA,
  GET_VENDOR_DASHBOARD_PO_DATA_BY_FILTER,
  GET_VENDOR_DASHBOARD_PR_JOB_ATTACHMENT,
  GET_VENDOR_DASHBOARD_QUOTATION,
  POST_VENDOR_DASHBOARD_CREATE_QUOTATION,
  DELETE_VENDOR_DASHBOARD_QUOATATION_ATTACHMENT,
  POST_VENDOR_DASHBOARD_ADDMORE_QUOTATION,
  POST_VENDOR_DASHBOARD_UPLOAD_PO_DOC,
  DELETE_VENDOR_DASHBOARD_PO_DOC,
  PATCH_VENDOR_DASHBOARD_UPDATE_PO_STATUS,
  GET_S3_SIGNED_URL,
  POST_VENDOR_DASHBOARD_ADDMORE_QUOTATION_V2,
  PO_HISTORY_LIST,
  PO_INDIVIDUAL_HISTORY,
  POST_VENDOR_DASHBOARD_UPLOAD_PO_DOC_V2,
} from "../../ApiEndPoints/ApiEndPoints";
import axios from "axios";
import TYPES from "../constants";
import { toast } from "react-toastify";
import { forEach } from "jszip";

export const fetchVendorStats = () => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_STATS_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.get(
        `${BaseUrl}${GET_VENDOR_DASHBOARD_STATS}`,
        { headers }
      );

      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_STATS_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_STATS_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_STATS_FAILURE,
        error: error.message,
      });
    }
  };
};

export const fetchPrList = (
  page = 1,
  pageSize = 5,
  searchByColumNameValue = {},
  orderBy = "updatedAt",
  orderDir = "DESC"
) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PR_LIST_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let url = `${BaseUrl}${GET_VENDOR_DASHBOARD_PR_LIST}?page=${page}&pageSize=${pageSize}&orderBy=${orderBy}&orderDir=${orderDir}`;
      if (
        searchByColumNameValue &&
        Object.keys(searchByColumNameValue).length > 0
      ) {
        url += `&searchByColumNameValue=${encodeURIComponent(
          JSON.stringify(searchByColumNameValue)
        )}`;
      }

      const response = await axios.get(url, { headers });

      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_LIST_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_LIST_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_PR_LIST_FAILURE,
        error: error.message,
      });
    }
  };
};

export const fetchPoList = (page = 1, pageSize = 10) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PO_LIST_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.get(
        `${BaseUrl}${GET_VENDOR_DASHBOARD_PO_DATA}?page=${page}&pageSize=${pageSize}&orderBy=updatedAt&orderDir=DESC`,
        { headers }
      );

      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PO_LIST_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PO_LIST_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_PO_LIST_FAILURE,
        error: error.message,
      });
    }
  };
};
export const fetchPrStatus = () => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PR_STATS_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.get(
        `${BaseUrl}${GET_VENDOR_DASHBOARD_PR_STATS}`,
        { headers }
      );

      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_STATS_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_STATS_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_PR_STATS_FAILURE,
        error: error.message,
      });
    }
  };
};
export const fetchPoStatus = () => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PO_STATS_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.get(
        `${BaseUrl}${GET_VENDOR_DASHBOARD_PO_STATS}`,
        { headers }
      );

      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PO_STATS_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PO_STATS_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_PO_STATS_FAILURE,
        error: error.message,
      });
    }
  };
};
export const fetchPrDataByFilter = (
  page = 1,
  pageSize = 5,
  orderBy = "updatedAt",
  orderDir = "ASC",
  filterStatus = 2
) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PRDATA_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.get(
        `${BaseUrl}${GET_VENDOR_DASHBOARD_PR_DATA_BY_FILTER}`,
        { headers, params: { page, pageSize, orderBy, orderDir, filterStatus } }
      );
      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PRDATA_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PRDATA_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_PRDATA_FAILURE,
        error: error.message,
      });
    }
  };
};
export const fetchPoDataByFilter = (
  page = 1,
  pageSize = 10,
  orderBy = "PoDbId",
  orderDir = "desc",
  filterStatus
) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PODATA_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const params = { page, pageSize, orderBy, orderDir };
      if (filterStatus !== undefined) {
        params.filterStatus = filterStatus;
      }
      const response = await axios.get(
        `${BaseUrl}${GET_VENDOR_DASHBOARD_PO_DATA_BY_FILTER}`,
        { headers, params }
      );
      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PODATA_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PODATA_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_PODATA_FAILURE,
        error: error.message,
      });
    }
  };
};

export const fetchPoHistoryList = (poId) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.PO_HISTORY_LIST_LOADING,
    });
    try {
      if (!poId) {
        toast.error("Invalid Po Id");
        throw new Error("Invalid Po Id");
      }
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(`${BaseUrl}${PO_HISTORY_LIST}/${poId}`, {
        headers,
      });
      if (response.status === 200) {
        dispatch({
          type: TYPES.PO_HISTORY_LIST_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: TYPES.PO_HISTORY_LIST_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.PO_HISTORY_LIST_FAILURE,
        error: error.message,
      });
    }
  };
};

export const fetchIndividualPoHistory = (id) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.PO_INDIVIDUAL_HISTORY_LOADING,
    });
    try {
      if (!id) {
        toast.error("Invalid Id");
        throw new Error("Invalid Id");
      }
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(`${BaseUrl}${PO_INDIVIDUAL_HISTORY}/${id}`, {
        headers,
      });
      if (response.status === 200) {
        dispatch({
          type: TYPES.PO_INDIVIDUAL_HISTORY_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: TYPES.PO_INDIVIDUAL_HISTORY_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Something went wrong";

      dispatch({
        type: TYPES.PO_INDIVIDUAL_HISTORY_FAILURE,
        error: error.message,
      });
      toast.error(message);
    }
  };
};

export const fetchPrJobAttachments = (jobId) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PR_ATTACHMENT_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.get(
        `${BaseUrl}${GET_VENDOR_DASHBOARD_PR_JOB_ATTACHMENT}`,
        {
          headers,
          params: { JobId: jobId },
        }
      );

      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_ATTACHMENT_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_ATTACHMENT_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_PR_ATTACHMENT_FAILURE,
        error: error.message,
      });
    }
  };
};
export const fetchPrJobQuotations = (jobId) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PR_QUOTATION_LOADING,
    });

    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.get(
        `${BaseUrl}${GET_VENDOR_DASHBOARD_QUOTATION}`,
        {
          headers,
          params: { JobId: jobId },
        }
      );

      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_QUOTATION_SUCCESS,
          payload: response?.data?.data,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_QUOTATION_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_PR_QUOTATION_FAILURE,
        error: error.message,
      });
    }
  };
};
export const deletePrJobQuotations = (JobQuotationId, QtAttachmentId) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PR_QUOTATION_DELETE_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.delete(
        `${BaseUrl}${DELETE_VENDOR_DASHBOARD_QUOATATION_ATTACHMENT}`,
        {
          headers,
          params: { JobQuotationId, QtAttachmentId },
        }
      );

      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_QUOTATION_DELETE_SUCCESS,
          payload: response.data.data.DeletedAttachment,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_QUOTATION_DELETE_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_PR_QUOTATION_DELETE_FAILURE,
        error: error.message,
      });
    }
  };
};

export const createJobQuotations = (jobId, files, phoneNo) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PR_CREATE_QUOTATION_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      };
      const formData = new FormData();
      formData.append("JobId", jobId);
      if (files) {
        files.forEach((file) => {
          formData.append("AttachmentFile", file);
        });
      }
      formData.append("phoneNo", phoneNo);

      const response = await axios.post(
        `${BaseUrl}${POST_VENDOR_DASHBOARD_CREATE_QUOTATION}`,
        formData,
        {
          headers,
        }
      );

      if (response.status === 200) {
        toast.success("Quotation added successfully");
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_CREATE_QUOTATION_SUCCESS,
          payload: response?.data.data,
        });
        return { success: true, data: response?.data.data?.QtAttachments };
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_CREATE_QUOTATION_FAILURE,
          error: "API request failed",
        });
        return { success: false, error: "API request failed" };
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_PR_CREATE_QUOTATION_FAILURE,
        error: error.message,
      });
      return { success: false, error: error.message };
    }
  };
};

export const addJobQuotations = (JobId, JobQuotationId, phoneNo, files) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PR_ADD_QUOTATION_LOADING,
    });

    try {
      const token = localStorage.getItem("vms_vendor_token");

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const payload = {
        JobId,
        JobQuotationId,
        phoneNo,
        files: files || [],
      };

      const response = await axios.post(
        `${BaseUrl}${POST_VENDOR_DASHBOARD_ADDMORE_QUOTATION_V2}`,
        payload,
        { headers }
      );
      if (response.status === 200 && response.data) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_ADD_QUOTATION_SUCCESS,
          payload: response.data.data?.QtAttachments,
        });
        return { success: true, data: response.data };
      } else {
        const errorMsg = response.data?.message || "API request failed";
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_ADD_QUOTATION_FAILURE,
          error: errorMsg,
        });
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      let errorMsg = "Failed to add quotation";

      if (error.response) {
        const { data, status } = error.response;

        if (status === 422 && data?.errors && Array.isArray(data.errors)) {
          errorMsg = data.errors.map((err) => err.msg).join(", ");
        } else if (data?.message) {
          errorMsg = data.message;
        } else if (data?.errors) {
          errorMsg = JSON.stringify(data.errors);
        }
      } else if (error.message) {
        errorMsg = error.message;
      }

      dispatch({
        type: TYPES.VENDOR_DASHBOARD_PR_ADD_QUOTATION_FAILURE,
        error: errorMsg,
      });

      return { success: false, error: errorMsg };
    }
  };
};

export const getS3SignedUrl = (payload) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.GET_S3_SIGNED_URL_LOADING,
    });

    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.post(
        `${BaseUrl}${GET_S3_SIGNED_URL}`,
        payload,
        { headers }
      );

      if (response.status === 200) {
        dispatch({
          type: TYPES.GET_S3_SIGNED_URL_SUCCESS,
          payload: response?.data?.data,
        });
        return response?.data?.data;
      } else {
        dispatch({
          type: TYPES.GET_S3_SIGNED_URL_FAILURE,
          error: "API request failed",
        });
        throw new Error("API request failed");
      }
    } catch (error) {
      dispatch({
        type: TYPES.GET_S3_SIGNED_URL_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const addMoreJobQuotations = (JobId, JobQuotationId, phoneNo, files) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PR_ADD_QUOTATION_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      };

      const formData = new FormData();
      formData.append("JobId", JobId);

      if (files) {
        files.forEach((file) => {
          formData.append("AttachmentFile", file);
        });
      }

      formData.append("JobQuotationId", JobQuotationId);
      formData.append("phoneNo", phoneNo);

      const response = await axios.post(
        `${BaseUrl}${POST_VENDOR_DASHBOARD_ADDMORE_QUOTATION}`,
        formData,
        {
          headers,
        }
      );

      if (response.status === 200) {
        toast.success("Quotation added successfully");
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_ADD_QUOTATION_SUCCESS,
          payload: response.data.data.QtAttachments,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_PR_ADD_QUOTATION_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_PR_ADD_QUOTATION_FAILURE,
        error: error.message,
      });
    }
  };
};

//upload po doc
export const uploadPoDoc = (id, files) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_UPLOAD_PO_DOC_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      
      const response = await axios.post(
        `${BaseUrl}${POST_VENDOR_DASHBOARD_UPLOAD_PO_DOC_V2}/${id}`,
        files,
        {
          headers,
        }
      );

      if (response.status === 201) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_UPLOAD_PO_DOC_SUCCESS,
          payload: response?.data?.data,
        });
        toast.success("PO Documents Uploaded successfully");
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_UPLOAD_PO_DOC_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_UPLOAD_PO_DOC_FAILURE,
        error: error.message,
      });
    }
  };
};
//delete po doc

export const deletePoDoc = (id) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_DELETE_PO_DOC_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.delete(
        `${BaseUrl}${DELETE_VENDOR_DASHBOARD_PO_DOC}/${id}`,
        {
          headers,
        }
      );
      if (response?.data?.status == 200) {
        toast.success(response?.data?.message);
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_DELETE_PO_DOC_SUCCESS,
          payload: id,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_DELETE_PO_DOC_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_DELETE_PO_DOC_FAILURE,
        error: error.message,
      });
    }
  };
};

export const updatePoDoc = (poDoc) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_PO_DOC_SUCCESS,
      payload: poDoc,
    });
  };
};

export const updateVendorStatus = (id) => {
  return async (dispatch) => {
    dispatch({
      type: TYPES.VENDOR_DASHBOARD_UPDATE_PO_STATUS_LOADING,
    });
    try {
      const token = localStorage.getItem("vms_vendor_token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.patch(
        `${BaseUrl}${PATCH_VENDOR_DASHBOARD_UPDATE_PO_STATUS}/${id}`,
        {},
        {
          headers,
        }
      );
      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_UPDATE_PO_STATUS_SUCCESS,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_DASHBOARD_UPDATE_PO_STATUS_FAILURE,
          error: "API request failed",
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      dispatch({
        type: TYPES.VENDOR_DASHBOARD_UPDATE_PO_STATUS_FAILURE,
        error: error.message,
      });
    }
  };
};

export const clearVendorDashboard = () => {
  return {
    type: TYPES.VENDOR_DASHBOARD_PRDATA_CLEAR,
  };
};